import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/:id?',
    exact: false,
    name: 'branches',
    component: loadableWithRetry(() => import('./BranchesContainer')),
  },
]

export default routes
